<script>
import Nav from "../components/pc/nav.vue";
import Bottom from "../components/pc/bottom.vue";
import Notice from "../components/pc/notice.vue";
export default {
  data() {
    return {
      bannerFixed: false,
    };
  },
  components: {
    Nav,
    Notice,
    Bottom,
  },
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 80) {
        this.bannerFixed = true;
      } else {
        this.bannerFixed = false;
      }
    },
  },
};
</script>
<template>
  <div class="home">
    <Nav :isFixed="bannerFixed"></Nav>
    <Notice></Notice>
    <Bottom></Bottom>
    <el-backtop target=".home"></el-backtop>
  </div>
</template>
<style lang="scss"></style>
